import type { ReportSection } from '../ReportSection.js'
import type { ProfileCaveat } from '../../../../../Model/Order/processingProfile.js'
import { describeInput } from '../../../../../Model/Order/processingProfile.js'
import { getSampleConfigurationLabel } from '../../../../../Util/sequencingPlatform.js'
import { SequencingPlatforms } from '../../../../../Generated/SequencingPlatform.js'
import { formatDate, parseDate } from '../../../../../Util/DateHandling.js'
import { DateTime } from 'luxon'

const CAVEAT_TEXT: Record<ProfileCaveat, string> = {
  PLATFORM_ASSUMED: 'No sequencing platform was recorded for this order; the processing is described as Illumina.',
  CLUSTERING_INFERRED:
    'The pipeline did not record the clustering method for this run; it is stated from the order’s amplicon and platform.'
}

export const cover: ReportSection = {
  id: 'cover',
  applies: () => true,
  Render: ({ data: { order, orderLab, profile } }) => (
    <section className="flex flex-col justify-between items-center text-center break-after-page h-[80vh]">
      <img src={'/logo.png'} alt="Logo" className="w-40 m-8" />

      <div className="flex flex-col justify-center items-center grow">
        <h1 className="text-4xl font-bold text-green-700 mb-4">DNA Metabarcoding Report</h1>
        <p className="text-lg">Order: {order.name}</p>
        {orderLab && <p className="text-lg">Lab: {orderLab.name}</p>}
        <p className="text-lg">Report Date: {formatDate(DateTime.now())}</p>
        {order.orderDone && <p className="text-lg">Completed: {formatDate(parseDate(order.orderDone))}</p>}
      </div>

      <div className="w-4/5 mb-4 text-left text-sm">
        <p>
          <span className="font-semibold">Input:</span> {getSampleConfigurationLabel(order.sampleConfiguration, profile.platform)}
        </p>
        <p className="text-gray-600">{describeInput(profile)}</p>
        <p>
          <span className="font-semibold">Sequencing platform:</span> {SequencingPlatforms[profile.platform].label}
          {profile.platformOverridden && ' (set by the lab)'}
        </p>
        {profile.caveats.length > 0 && (
          <ul className="mt-2 rounded-md border border-amber-300 bg-amber-50 px-4 py-2 text-amber-900 list-disc list-inside">
            {profile.caveats.map((caveat) => (
              <li key={caveat}>{CAVEAT_TEXT[caveat]}</li>
            ))}
          </ul>
        )}
      </div>
    </section>
  )
}
